'use client';

import React, { useState, useCallback, useEffect } from 'react';
import styles from './styles/modals.module.css';

export default function WhatsIncludedModal({
  isOpen,
  onClose,
  whatsIncludedContent,
  setWhatsIncludedContent,
  onSave
}) {
  if (!isOpen) return null;

  const [content, setContent] = useState(() => {
    if (whatsIncludedContent && typeof whatsIncludedContent === 'object') {
      return `Title 1: ${whatsIncludedContent.title1}\n${whatsIncludedContent.content1}\n\nTitle 2: ${whatsIncludedContent.title2}\n${whatsIncludedContent.content2}\n\nTitle 3: ${whatsIncludedContent.title3}\n${whatsIncludedContent.content3}\n\nTitle 4: ${whatsIncludedContent.title4}\n${whatsIncludedContent.content4}`;
    }
    return whatsIncludedContent || '';
  });
  const close = useCallback(() => {
    onClose();
  }, [onClose]);


  const handleSave = () => {
    // Parse the content back to structured format for backward compatibility
    const sections = content.split('\n\n');
    const structuredData = {
      title1: '', content1: '',
      title2: '', content2: '',
      title3: '', content3: '',
      title4: '', content4: ''
    };

    sections.forEach((section, index) => {
      if (index < 4) {
        const lines = section.split('\n');
        const titleMatch = lines[0]?.match(/^Title \d+: (.+)$/);
        if (titleMatch) {
          structuredData[`title${index + 1}`] = titleMatch[1];
          structuredData[`content${index + 1}`] = lines.slice(1).join('\n');
        } else {
          // If no title format, treat the whole section as content
          structuredData[`title${index + 1}`] = `Section ${index + 1}`;
          structuredData[`content${index + 1}`] = section;
        }
      }
    });

    // Call onSave with all 8 parameters for backward compatibility
    onSave(
      structuredData.title1, structuredData.content1,
      structuredData.title2, structuredData.content2,
      structuredData.title3, structuredData.content3,
      structuredData.title4, structuredData.content4
    );
  };

  return (
    // clicking overlay closes
    <div className={styles.modal} onClick={close}>
      {/* prevent closing when clicking inside */}
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        {/* X mark for closing */}
        <button
          type="button"
          className={styles.close}
          onClick={close}
          aria-label="Close"
        >
          &times;
        </button>

        <h2 className={styles.modalTitle}>Edit "What's Included" Section</h2>

        <div className={styles.formGroup}>
          <label className={styles.label}>
            What's Included Content
            <span className={styles.helperText}>
              Enter what's included in this course. You can use "Title X:" format to create sections.
            </span>
          </label>
          <textarea
            className={styles.textarea}
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder={`Title 1: Interactive Sessions
Learn through engaging, hands-on activities...

Title 2: Course Materials
All materials and resources provided...

Title 3: Expert Instruction
Taught by experienced educators...

Title 4: Certificate
Receive a certificate upon completion...`}
            rows={20}
          />
        </div>

        <div className={styles.modalActions}>
          <button className={styles.saveBtn} onClick={handleSave}>
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
}